import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import ClientList from './components/views/ClientList';
import ClientOverview from './components/views/ClientOverview';
import DimensionDetail from './components/views/DimensionDetail';
import ClientReport from './components/views/ClientReport';
import ProjectManagement from './components/views/ProjectManagement';
import GuideLibrary from './components/views/GuideLibrary';
import GuideReader from './components/views/GuideReader';
import ClientGuides from './components/views/ClientGuides';
import AuditIntakeAgent from './components/views/AuditIntakeAgent';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/clients" replace />} />
        <Route element={<Layout />}>
          <Route path="/clients" element={<ClientList />} />
          <Route path="/clients/:id" element={<ClientOverview />} />
          <Route path="/clients/:id/intake" element={<AuditIntakeAgent />} />
          <Route path="/clients/:id/dimension/:num" element={<DimensionDetail />} />
          <Route path="/clients/:id/report" element={<ClientReport />} />
          <Route path="/clients/:id/project" element={<ProjectManagement />} />
          <Route path="/clients/:id/guides" element={<ClientGuides />} />
          <Route path="/guides" element={<GuideLibrary />} />
          <Route path="/guides/:slug" element={<GuideReader />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
